import { Box, Checkbox, Stack } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from '@mui/material/Tooltip';
import * as React from "react";
import { TABLE_BODY_ROW_MUI_STYLES, TABLE_HEADER_ROW_MUI_STYLES } from "../utils/constant";
import CustomPagination from "../utils/CustomPagination";

export default function CustomTable({
  cols,
  onPageChange,
  data,
  isCheckbox = false,
  actionComp,
  count,
  handleCheckbox,
  checkboxData = [],
  removeAllChecked,
}) {

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [openTooltipIndexes, setOpenTooltipIndexes] = React.useState([]);
  const tooltipRefs = React.useRef([]);
  const tableRef = React.useRef();
  const handleTooltipToggle = (cellIndex) => {
    setOpenTooltipIndexes(openTooltipIndexes.includes(cellIndex) ? [] : [cellIndex]);
  };

  const handleDocumentClick = (event) => {
    const clickedOutsideAllTooltips = tooltipRefs.current.every(ref => ref && !ref.contains(event.target));
    if (clickedOutsideAllTooltips) {
      setOpenTooltipIndexes([]);
    }
  };

  React.useEffect(() => {
    document.addEventListener('click', handleDocumentClick);

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, []);


  const handleChangePage = (newPage) => {
    setPage(newPage-1);
    onPageChange({ rows: rowsPerPage, page: newPage - 1 });
  };


  React.useEffect(() => {
    document.addEventListener('click', handleDocumentClick);

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, []);

  const rows = data.map((item) => {
    return [
      // first element of the array is to show data in the table rows
      cols.map((data) => item[data]),
      // second element is for passing entire object which we get from get API i.e. data in the props
      { ...item },
    ];
  });

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage((page) => {
      onPageChange({ rows: event.target.value, page: 0 });
      return event.target.value;
    });
    setPage(0);
  };

  React.useEffect(() => {
    const tableContainer = tableRef.current;
    const handleScroll = () => {
      if (tableContainer && false) {
        const { scrollTop, clientHeight, scrollHeight } = tableContainer;
        if (Math.ceil(scrollTop + clientHeight) >= scrollHeight - 1) {
          setRowsPerPage((page) => {
            onPageChange({ rows: page + 10, page: 0 });
            return page + 10;
          });

        }
      }
    };
    tableContainer.addEventListener('scroll', handleScroll);
    return () => {
      tableContainer.removeEventListener('scroll', handleScroll);
    };
  });

  return (
    <Box>
      <TableContainer  stickyHeader ref={tableRef}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow sx={TABLE_HEADER_ROW_MUI_STYLES}>
              {isCheckbox && data?.filter((v) => v.status === "PENDING")?.length > 0 && false && (
                <TableCell padding={"checkbox"}>
                  <Checkbox
                    color="primary"
                    checked={checkboxData.length > 0}
                    onChange={removeAllChecked}
                    inputProps={{
                      "aria-label": "select all",
                    }}
                  ></Checkbox>
                </TableCell>
              )}
              {cols.map((column) => (
                <TableCell
                  align="left"
                  key={column}

                >
                  {column?.split("_")?.join(" ")?.capitalize()}
                </TableCell>
              ))}
              {actionComp && (
                <TableCell
                  align="left"
                >
                  Action
                </TableCell>
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows?.length > 0 ? rows?.map((row, rowIndex) => (
              <TableRow key={rowIndex} sx={TABLE_BODY_ROW_MUI_STYLES}>
                {row[0].map((item, cellIndex) => {
                  const cellTooltipIndex = rowIndex * row[0].length + cellIndex;
                  const isOpen = openTooltipIndexes.includes(cellTooltipIndex);
                  return (
                    <TableCell align="left" key={cellIndex}>
                      {item != null && item.length > 20 ? (
                        <div >
                          <Tooltip
                            ref={ref => tooltipRefs.current[cellTooltipIndex] = ref}
                            title={item}
                            PopperProps={{
                              disablePortal: true,
                            }}
                            arrow={true}
                            open={isOpen}
                            disableFocusListener
                            disableTouchListener
                            disableInteractive
                          >
                            <span
                              className="showhandCursor"
                              onClick={() => handleTooltipToggle(cellTooltipIndex)}
                            >
                              {item.slice(0, 20)}
                            </span>
                          </Tooltip>
                          {!isOpen && <Tooltip title={item} arrow={true}>
                            <span className="showhandCursor">...</span>
                          </Tooltip>}
                        </div>
                      ) : (
                        <span>{item}</span>
                      )}
                    </TableCell>
                  );
                })}
                {actionComp && (
                  <TableCell align="left" sx={{ minWidth: 150 }} width={150}>
                    {actionComp(row[1])}
                  </TableCell>
                )}
              </TableRow>
            )) : (
              <TableRow>
                <TableCell align="center" colSpan={10}>
                  No Data Found!
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
         <Stack
            sx={{
              background: 'transparent',
              height: '60px',
              border: '1px solid #E9EAEB'
            }}
            direction="row"
            alignItems={"center"}
            justifyContent={"flex-end"}>
            <CustomPagination
              count={Math.ceil(count / rowsPerPage) || 0}
              onChange={handleChangePage}
              currentPage={page}
              handleChangePerPage={handleChangeRowsPerPage}
              limit={rowsPerPage}
              listingCount={rows?.length}
              totalCount={count}
              defaultPage={1} siblingCount={1} boundaryCount={1} />
          </Stack>
    </Box>
  );
}
